// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__18XhJ","Hollow":"Button_Hollow__1PcqB","Solid":"Button_Solid__r3UL7","small":"Button_small__1Lhsj"};